import { createTheme } from "@mui/material/styles";

const Palette = () => {
  return createTheme({
    palette: {
      background: {
        default: "#F2EFE7",
      },
      common: {
        black: "#000000",
        white: "#FFFFFF",
      },
      text: {
        primary: "#0B1A2B",
        secondary: "rgba(11,26,43,.6)",
      },
      custom: {
        primary: "#FC5719",
        primaryDim: "#c94614",
        ink: "#0B1A2B",
        ink2: "#13263D",
        paper: "#F2EFE7",
        paper2: "#E7E2D5",
      },
    },
  });
};

export default Palette;
